// extracted by mini-css-extract-plugin
export default {"poster":"Poster_poster__k41Ta","poster_inner":"Poster_poster_inner__DWMTC"};